import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormRhombus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFormRhombus"><Path d="M5.5587 11.4855L11.1425 2.17915C11.5309 1.53182 12.4691 1.53182 12.8575 2.17916L18.4413 11.4855C18.6313 11.8022 18.6313 12.1978 18.4413 12.5145L12.8575 21.8208C12.4691 22.4682 11.5309 22.4682 11.1425 21.8208L5.5587 12.5145C5.36869 12.1978 5.36869 11.8022 5.5587 11.4855Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFormRhombus;
